<template>
  <div class="table__tr" :class="{'table__tr--inactive': !promocode.isValid}">
    <!-- Код -->
    <div class="table__td">
      <div class="promocode-code">
        <p class="text-black text-bold">{{ promocode.code }}</p>
        <span class="badge badge--personal" v-if="promocode.isPersonal" title="Персональный">П</span>
      </div>
    </div>
    <!-- Срок действия -->
    <div class="table__td">
      <div class="promocode-dates">
        <p class="text-grey">С</p>
        <p class="text-black">{{ formatDate(promocode.startDt) }}</p>
        <p class="text-grey">По</p>
        <p class="text-black">{{ formatDate(promocode.endDt) }}</p>
      </div>
    </div>
    <!-- Период -->
    <div class="table__td">
      <div class="promocode-period">
        <p class="text-black">{{ getPeriodLabel(promocode.period) }}</p>
        <p class="text-grey" v-if="promocode.periodsCount > 1">x{{ promocode.periodsCount }}</p>
      </div>
    </div>
    <!-- Сумма -->
    <div class="table__td">
      <div class="promocode-amount">
        <p class="text-black" v-if="promocode.amount !== null">{{ formatAmount(promocode.amount) }}</p>
        <p class="text-grey" v-else>-</p>
      </div>
    </div>
    <!-- Тип организации -->
    <div class="table__td">
      <div class="promocode-org-type">
        <p class="text-black" v-if="promocode.userOrganizationType">{{ getOrgTypeLabel(promocode.userOrganizationType) }}</p>
        <p class="text-grey" v-else>Все</p>
      </div>
    </div>
    <!-- Триал -->
    <div class="table__td">
      <div class="promocode-trial">
        <template v-if="promocode.hasTrialPeriod">
          <span class="badge badge--trial">{{ promocode.trialPeriodDays }} дн.</span>
          <p class="text-grey" v-if="promocode.trialAmount">{{ formatAmount(promocode.trialAmount) }}</p>
        </template>
        <p class="text-grey" v-else>-</p>
      </div>
    </div>
    <!-- Статус -->
    <div class="table__td">
      <div class="promocode-status">
        <span class="status-badge" :class="promocode.isValid ? 'status-badge--active' : 'status-badge--inactive'">
          {{ promocode.isValid ? 'Активен' : 'Неактивен' }}
        </span>
        <p class="text-grey text-small" v-if="promocode.usersCount > 0">{{ promocode.usersCount }} акт.</p>
      </div>
    </div>
    <!-- Действия -->
    <div class="table__td">
      <div class="promocode-actions">
        <button class="action-btn action-btn--edit" @click="$emit('edit', promocode)" title="Редактировать">
          <img src="@/assets/images/icons/pencil.svg" alt="edit">
        </button>
        <button class="action-btn action-btn--delete" @click="$emit('delete', promocode)" title="Удалить">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 6H5M19 6V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20V6M8 6V4C8 2.89543 8.89543 2 10 2H14C15.1046 2 16 2.89543 16 4V6M10 11V17M14 11V17" stroke="#C62828" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    promocode: {
      type: Object,
      require: true
    },
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(+timestamp)
      return this.$options.filters.moment(Math.floor(date.getTime() / 1000.0), 'DD.MM.YYYY HH:mm')
    },
    formatAmount(amount) {
      return amount.toLocaleString('ru-RU') + ' ₽'
    },
    getPeriodLabel(period) {
      const labels = {
        'DAY': 'День',
        'WEEK': 'Неделя',
        'MONTH': 'Месяц',
        'LIFETIME': 'Бессрочно'
      }
      return labels[period] || period
    },
    getOrgTypeLabel(orgType) {
      const labels = {
        'LLC': 'ООО',
        'JSC': 'АО',
        'INDIVIDUAL_ENTREPRENEUR': 'ИП',
        'INDIVIDUAL': 'Физлицо',
        'SELF_EMPLOYED': 'Самозан.'
      }
      return labels[orgType] || orgType
    }
  }
}
</script>

<style lang="scss" scoped>
.table__tr--inactive {
  opacity: 0.6;
}

.table__tr {
  display: flex;
  border-bottom: 1px solid #F0F0F0;

  &:hover {
    background: #FAFAFA;
  }
}

.table__td {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.2rem 0.6rem;
  min-width: 0;

  &:nth-of-type(1) { flex: 0 0 10rem; justify-content: flex-start; }
  &:nth-of-type(2) { flex: 0 0 14rem; }
  &:nth-of-type(3) { flex: 0 0 8rem; }
  &:nth-of-type(4) { flex: 0 0 8rem; }
  &:nth-of-type(5) { flex: 0 0 8rem; }
  &:nth-of-type(6) { flex: 0 0 8rem; }
  &:nth-of-type(7) { flex: 0 0 8rem; }
  &:last-child { flex: 0 0 8rem; }
}

.promocode-code {
  display: flex;
  align-items: center;
  gap: 0.6rem;

  .text-bold {
    font-weight: 600;
    font-family: monospace;
    font-size: 1.3rem;
    text-transform: uppercase;
  }
}

.promocode-dates {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 1.1rem;
  text-align: center;
}

.promocode-period,
.promocode-amount,
.promocode-org-type,
.promocode-trial {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
  font-size: 1.2rem;
}

.promocode-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
}

.text-black {
  color: #191B1D;
}

.text-grey {
  color: #8A8C96;
  font-size: 1.1rem;
}

.text-small {
  font-size: 1rem;
}

.badge {
  padding: 0.2rem 0.5rem;
  border-radius: 0.4rem;
  font-size: 1rem;
  font-weight: 500;

  &--personal {
    background-color: #E8EAF6;
    color: #3F51B5;
  }

  &--trial {
    background-color: #FFF3E0;
    color: #E65100;
  }
}

.status-badge {
  padding: 0.4rem 0.8rem;
  border-radius: 1.2rem;
  font-size: 1.1rem;
  font-weight: 500;
  white-space: nowrap;

  &--active {
    background-color: #E8F5E9;
    color: #2E7D32;
  }

  &--inactive {
    background-color: #FFEBEE;
    color: #C62828;
  }
}

.promocode-actions {
  display: flex;
  gap: 0.6rem;
  justify-content: center;
}

.action-btn {
  width: 2.8rem;
  height: 2.8rem;
  border: none;
  border-radius: 0.6rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  img, svg {
    width: 1.4rem;
    height: 1.4rem;
  }

  &--edit {
    background-color: #E3F2FD;
    &:hover {
      background-color: #BBDEFB;
    }
  }

  &--delete {
    background-color: #FFEBEE;
    &:hover {
      background-color: #FFCDD2;
    }
  }
}
</style>
